import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { StaticHtmlService } from '@core/services/static-html.service';

@Component({
    selector: 'help-modal',
    templateUrl: 'help-modal.component.html',
    styleUrls: ['./help-modal.component.scss']
    
})

export class HelpModalComponent implements OnInit {

    @Input() title: string;
    @Input() display: boolean;
    @Input() dataModal: any;
    @Output() hideModal = new EventEmitter<any>();
    infoHtml: any = null;

    constructor(
        private staticHtmlService: StaticHtmlService,
        private router: Router
    ) { }

    ngOnInit() { 
        this.infoHtml = this.dataModal;
    }
    
    closeModal(data) {
		this.hideModal.emit(data)
	}
}